// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609140104/js/" + chunkId + "." + {"44":"945edc2a","225":"a40f09c3","481":"c64da5cc","486":"e0b9940d","770":"5c4a5762"}[chunkId] + ".0.5584933563207874.chunk.js";
};